// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.events-table .table-active,\n.events-table .table-active:hover {\n  background: #007bff !important;\n  color: #fff !important;\n}\n.events-table .table-active:hover td {\n  color: #fff !important;\n}\n.events-table .b-table-sticky-header {\n  max-height: 200px !important;\n}\n", ""]);
// Exports
module.exports = exports;
